import {useCurrentUser} from './useCurrentUser';
import {UserPreferences} from '#common/users/types';

export function useUserPreferences(): UserPreferences {
  return useCurrentUser().get().preferences;
}
